import React from 'react';
import { GeckoCardImage, GeckoBtn } from 'ui';

const IntegrationCard = ({
  integrationType,
  doesExist,
  isSetup,
  isDisabled,
  name,
  image,
  description,
  onInfoClick,
  onSetupClick,
  onManageClick,
  onDeleteClick,
  onContinueSetupClick,
  hasNewTag,
}) => {
  const setupButton = {
    name: 'Setup',
    handler: onSetupClick,
    disabledWhen: () => isDisabled === true,
  };
  const shouldShowSetupButton = doesExist === false;
  const manageButton = {
    name: 'Manage',
    handler: onManageClick,
    disabledWhen: () => isDisabled === true,
  };

  const shouldShowManageButton = doesExist === true && isSetup === true;
  const continueSetupButton = {
    name: 'Continue setup',
    handler: onContinueSetupClick,
    disabledWhen: () => isDisabled === true,
  };
  const shouldShowContinueButton = doesExist === true && isSetup === false;
  const button =
    shouldShowSetupButton === true
      ? setupButton
      : shouldShowManageButton === true
        ? manageButton
        : isSetup === false
          ? continueSetupButton
          : null;
  const deleteButton = {
    className: 'gecko-btn btn icon-only btn-naked-danger far fa-trash-alt Integration-delete-button',
    onClick: onDeleteClick,
  };
  const infoButton = {
    className: 'fas fa-question-circle Integration-info-button',
    onClick: onInfoClick,
  };

  const getHeading = () => {
    const newFlag = hasNewTag ? <span className="badge bg-info">New</span> : '';
    return (
      <h2>
        {name} <i {...infoButton} /> {newFlag}
      </h2>
    );
  };

  return (
    <GeckoCardImage img={image} alt={`${name} Logo`} padded>
      {getHeading()}
      <p>{description}</p>
      <div className="d-flex align-items-center justify-content-between">
        {button && <GeckoBtn {...button} />}
        {isSetup ? <button {...deleteButton}></button> : null}
      </div>
    </GeckoCardImage>
  );
};

export default IntegrationCard;
